import { memo, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateBrowserControlState } from '@wg/web2clientapi/browser/updateBrowserControlState';
import { playButtonSound } from '@wg/web2clientapi/sound';
import { DivTooltip, Tooltip, TooltipBody } from '@wg/wows-react-uikit';

import { root } from '~/preloaded';
import { isInGame } from '~/constants';
import { t } from '~/helpers/localization';
import { useAppDispatch } from '~/store';
import { actionsProcessing } from '~/Actions/ActionProcessing';

import { ReturnUrlContext } from '~/Providers/ReturnUrl';

import styles from './Back.module.scss';

import type { MouseEventHandler } from 'react';

interface BackProps {
  label?: string;
  shouldGoToRoot?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const Back = ({ label, shouldGoToRoot = false, onClick }: BackProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const returnUrl = useContext(ReturnUrlContext);

  const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    void playButtonSound();

    if (onClick) {
      onClick?.(e);
    }

    if (returnUrl) {
      dispatch(actionsProcessing.startFetching());
      void updateBrowserControlState(false);
      window.location.href = returnUrl;
      return;
    }

    if (location.key === 'default' || shouldGoToRoot || window.history.length <= 1) {
      navigate(root);
      return;
    }

    navigate(-1);
  };

  if (returnUrl && !isInGame) {
    return null;
  }

  return (
    <div className={styles.base} onClick={handleClick}>
      {shouldGoToRoot ? (
        label ?? t('Назад')
      ) : (
        <DivTooltip
          tooltipBody={
            <Tooltip>
              <TooltipBody>{t('Вернуться назад:tooltip')}</TooltipBody>
            </Tooltip>
          }
        >
          {label ?? t('Назад')}
        </DivTooltip>
      )}
    </div>
  );
};

export default memo(Back);
